import { AppData } from "../../game/AppData";
import { EventHandler } from "../../util/event/EventHandler";
import { Logger } from "../../util/log/Logger";
import { WebUtil } from "../../util/web/WebUtil";
import { GameConfigsRequest } from "../request/GameConfigsRequest";
/*
 * GameConfigHandler.ts
 */
export class GameConfigHandler {
    constructor(factory) {
        this.factory = factory;
        this.jurisdiction = this.factory.getWrapperConfig().getOperator().getJurisdiction();
        this.gameId = this.factory.getWrapperConfig().getOperatorParameters().getGameId();
    }
    load() {
        let filePath = this.getPath() + "gameConfigs.xml";
        let request = new GameConfigsRequest(filePath, this.factory);
        request.onComplete(this.handleConfigsComplete, this);
        request.load();
    }
    handleConfigsComplete(request) {
        this.gameConfigs = request.getGameConfigs();
        let jurisdictionId = "UK"; //Default to UK config for any jurisdiction that is not set
        if (this.jurisdiction != null) {
            jurisdictionId = this.jurisdiction.getId();
        }
        let key = this.gameId + "-" + jurisdictionId.toLowerCase();
        if (this.gameConfigs.containsKey(key)) {
            this.activeGameConfig = this.gameConfigs.getValue(key);
            Logger.debug("Game config found for key: " + key);
        }
        else {
            Logger.error("Game config not found for key: " + key);
        }
        this.handleComplete();
    }
    getPath() {
        let filePath;
        let testConfig = WebUtil.getUrlParameter("testConfig");
        if (testConfig == "local") {
            filePath = "test/xml/";
        }
        else if (AppData.DEPLOY_TYPE.isNative() /*|| AppData.DEPLOY_TYPE.isNativeLite()*/) {
            filePath = "xml/";
        }
        else {
            filePath = window.location.origin + "/rgs/xml/";
        }
        return filePath;
    }
    onComplete(handler, scope) {
        this.completeHandler = new EventHandler(handler, scope);
    }
    getActiveConfig() {
        return this.activeGameConfig;
    }
    handleComplete() {
        this.callHandler(this.completeHandler);
    }
    callHandler(handler) {
        if (handler) {
            handler.call(this);
        }
    }
}
//# sourceMappingURL=GameConfigHandler.js.map